import { z } from "zod";
export const TaskStatusSchema = z.enum(["todo", "inProgress", "done"]);
export const TaskPrioritySchema = z.enum(["low", "medium", "high"]);
export const TaskCategorySchema = z.enum([
    "venue",
    "catering",
    "photography",
    "music",
    "flowers",
    "attire",
    "transport",
    "beauty",
    "invitations",
    "ceremony",
    "honeymoon",
    "other",
]);
export const TaskSchema = z.object({
    id: z.string(),
    title: z.string().min(1),
    description: z.string().nullable().optional(),
    dueDate: z.string().datetime().nullable().optional(),
    priority: TaskPrioritySchema.default("medium"),
    status: TaskStatusSchema.default("todo"),
    category: TaskCategorySchema,
    assigneeId: z.string().nullable().optional(),
    completedAt: z.string().datetime().nullable().optional(),
    /** Google Calendar event id that mirrors this task (populated by the sync worker). */
    googleEventId: z.string().nullable().optional(),
    googleSyncedAt: z.string().datetime().nullable().optional(),
    googleSyncError: z.string().nullable().optional(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
